import hr from './hr';
import en from './en';

export default {
  hr,
  en,
};
